import { sample } from 'effector';
import { saveIsNewTicketsVersionToLocalStorage, ticketsVersionForm } from './model';

sample({
  clock: ticketsVersionForm.setValue,
  filter: ({ path }) => path === 'newVersion',
  fn: ({ value }) => value,
  target: saveIsNewTicketsVersionToLocalStorage,
});
